export const LEARNING_HISTORY_ROUTES = {
  SUMMARY: {
    NAME: "learning-history-summary",
    PATH: "/learning-history/summary"
  },
  EXERCISE_LOGS: {
    NAME: "learning-history-exercise-logs",
    PATH: "/learning-history/exercise-logs"
  }
};
